import React from 'react';

import { Field } from 'formik';

import SelectField from '../../components/SelectField';

import { MARGIN_TOP } from '../../config/constants';
import pms_purchase_status from '../../constants/pms_purchase_status';
import pms_purchase_transaction_type from '../../constants/pms_purchase_transaction_type';

const PurchaseFields = () => {
  return (
    <React.Fragment>
      <Field
        name="purchase_status"
        component={SelectField}
        label="Purchase Status *"
        options={pms_purchase_status}
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />

      <Field
        name="prchs_trnsctn_type"
        component={SelectField}
        label="Purchase Transaction Type *"
        options={pms_purchase_transaction_type}
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />
    </React.Fragment>
  );
};

export default PurchaseFields;



// WEBPACK FOOTER //
// ./src/Screens/ExtraPanels/PurchaseFields.js